import React, { useEffect, useState } from "react";
import {RadioComponent} from "../util/RadioComponent";
import AppConstants from "../../util/AppConstants";
import AppUtil from "../../util/AppUtil";

const OptionConfigComponent: React.FC = () => {
    const [isNormalMode, setIsNormalMode] = useState(true);

    useEffect(() => {
        if (isNormalMode) AppUtil.mode = AppConstants.MODE_NORMAL;
        else AppUtil.mode = AppConstants.MODE_LAST_PRICE;
    }, [isNormalMode]);

    return (
        <div className="option-config-row">
            <RadioComponent text="normal mode" actual={isNormalMode} val={true} set={setIsNormalMode} />
            <RadioComponent text="last price mode" actual={isNormalMode} val={false} set={setIsNormalMode} />
        </div>
    );
};

export default OptionConfigComponent; 